var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',{attrs:{"data-role":"Title"}},[_c('text',{staticClass:"chart-title",attrs:{"x":_vm.CHART_SIZE.width / 2,"y":_vm.CHART_SIZE.marginTop / 3}},[_vm._v("\n    Time between 1st and 2nd purchases\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }